import { createPublicApi } from './publicApi';
const publicApi = createPublicApi();

export const fetchPlayerIframeCode = (settings) => {
    return publicApi.getPlayerIframe(settings);
};
export const fetchShowBySlug = (slug) => {
    return publicApi.getShowBySlug(slug);
};
